export const REQUIRED_HEADERS_MONTHLY = [
    "S.N.",
    "Staff Name",
    "Staff Manager",
    "Staff Manager ID",
    "Staff Type",
    "Staff ID",
    "Role",
    "Salary/PH",
];

export const REQUIRED_HEADERS_DAILY = [
    "S.N.",
    "Name",
    "Staff EMP_ID",
    "Date",
    "Shift",
    "In Time",
    'Out Time'
];

export const excelTypes = [
    {
        value: "monthly",
        label: "Monthly Excel"
    },
    {
        value: "daily",
        label: "Daily Excel"
    }
]

const monthlyColumns = (rowErrors,headers) => {
    return [
        {
            title: "S.N.",
            dataIndex: 's.n.',
            key: 's.n.',
            width: 160,
            render: (_, record) => {
                const isMissing =
                    rowErrors[record.key] && rowErrors[record.key].includes(header);

                return (
                    <Input
                        value={record[header]}
                        onChange={(e) =>
                            handleCellChange(record.key, header, e.target.value)
                        }
                        size="small"
                        style={
                            isMissing
                                ? {
                                    border: "1px solid #ff4d4f",
                                    background: "#fff1f0",
                                    color: "#a8071a",
                                }
                                : {}
                        }
                    />
                );
            },
        },
        {
            title: "Salary/PH",
            dataIndex: 'salary/ph',
            key: 'salary/ph',
            width: 160,
            render: (_, record) => {
                const isMissing =
                    rowErrors[record.key] && rowErrors[record.key].includes(header);

                return (
                    <Input
                        value={record[header]}
                        onChange={(e) =>
                            handleCellChange(record.key, header, e.target.value)
                        }
                        size="small"
                        style={
                            isMissing
                                ? {
                                    border: "1px solid #ff4d4f",
                                    background: "#fff1f0",
                                    color: "#a8071a",
                                }
                                : {}
                        }
                    />
                );
            },
        },
        {
            title: "Staff ID",
            dataIndex: 'staff_id',
            key: 'staff_id',
            width: 160,
            render: (_, record) => {
                const isMissing =
                    rowErrors[record.key] && rowErrors[record.key].includes(header);

                return (
                    <Input
                        value={record[header]}
                        onChange={(e) =>
                            handleCellChange(record.key, header, e.target.value)
                        }
                        size="small"
                        style={
                            isMissing
                                ? {
                                    border: "1px solid #ff4d4f",
                                    background: "#fff1f0",
                                    color: "#a8071a",
                                }
                                : {}
                        }
                    />
                );
            },
        },
        {
            title: "Staff Manager",
            dataIndex: 'staff_manager',
            key: 'staff_manager',
            width: 160,
            render: (_, record) => {
                const isMissing =
                    rowErrors[record.key] && rowErrors[record.key].includes(header);

                return (
                    <Input
                        value={record[header]}
                        onChange={(e) =>
                            handleCellChange(record.key, header, e.target.value)
                        }
                        size="small"
                        style={
                            isMissing
                                ? {
                                    border: "1px solid #ff4d4f",
                                    background: "#fff1f0",
                                    color: "#a8071a",
                                }
                                : {}
                        }
                    />
                );
            },
        },
        {
            title: "Staff Manager ID",
            dataIndex: 'staff_manager_id',
            key: 'staff_manager_id',
            width: 160,
            render: (_, record) => {
                const isMissing =
                    rowErrors[record.key] && rowErrors[record.key].includes(header);

                return (
                    <Input
                        value={record[header]}
                        onChange={(e) =>
                            handleCellChange(record.key, header, e.target.value)
                        }
                        size="small"
                        style={
                            isMissing
                                ? {
                                    border: "1px solid #ff4d4f",
                                    background: "#fff1f0",
                                    color: "#a8071a",
                                }
                                : {}
                        }
                    />
                );
            },
        },
        {
            title: "Staff Name",
            dataIndex: 'staff_name',
            key: 'staff_name',
            width: 160,
            render: (_, record) => {
                const isMissing =
                    rowErrors[record.key] && rowErrors[record.key].includes(header);

                return (
                    <Input
                        value={record[header]}
                        onChange={(e) =>
                            handleCellChange(record.key, header, e.target.value)
                        }
                        size="small"
                        style={
                            isMissing
                                ? {
                                    border: "1px solid #ff4d4f",
                                    background: "#fff1f0",
                                    color: "#a8071a",
                                }
                                : {}
                        }
                    />
                );
            },
        },
        {
            title: "Staff Type",
            dataIndex: 'staff_type',
            key: 'staff_type',
            width: 160,
            render: (_, record) => {
                const isMissing =
                    rowErrors[record.key] && rowErrors[record.key].includes(header);

                return (
                    <Input
                        value={record[header]}
                        onChange={(e) =>
                            handleCellChange(record.key, header, e.target.value)
                        }
                        size="small"
                        style={
                            isMissing
                                ? {
                                    border: "1px solid #ff4d4f",
                                    background: "#fff1f0",
                                    color: "#a8071a",
                                }
                                : {}
                        }
                    />
                );
            },
        },
        {
            title: "Update",
            dataIndex: 'update',
            key: 'update',
            width: 160,
            render: (_, record) => {
                const isMissing =
                    rowErrors[record.key] && rowErrors[record.key].includes(header);

                return (
                    <Input
                        value={record[header]}
                        onChange={(e) =>
                            handleCellChange(record.key, header, e.target.value)
                        }
                        size="small"
                        style={
                            isMissing
                                ? {
                                    border: "1px solid #ff4d4f",
                                    background: "#fff1f0",
                                    color: "#a8071a",
                                }
                                : {}
                        }
                    />
                );
            },
        },
    ]
}

const dailyColumns = (rowErrors,headers) => {
    return (
        [
            {
                title: "S.N.",
                dataIndex: 's.n.',
                key: 's.n.',
                width: 160,
                render: (_, record) => {
                    const isMissing =
                        rowErrors[record.key] && rowErrors[record.key].includes(header);

                    return (
                        <Input
                            value={record[header]}
                            onChange={(e) =>
                                handleCellChange(record.key, record, e.target.value)
                            }
                            size="small"
                            style={
                                isMissing
                                    ? {
                                        border: "1px solid #ff4d4f",
                                        background: "#fff1f0",
                                        color: "#a8071a",
                                    }
                                    : {}
                            }
                        />
                    );
                },
            },
            {
                title: "Staff EMP_ID",
                dataIndex: 'staff_emp_id',
                key: 'staff_emp_id',
                width: 160,
                render: (_, record) => {
                    const isMissing =
                        rowErrors[record.key] && rowErrors[record.key].includes(header);

                    return (
                        <Input
                            value={record[header]}
                            onChange={(e) =>
                                handleCellChange(record.key, record, e.target.value)
                            }
                            size="small"
                            style={
                                isMissing
                                    ? {
                                        border: "1px solid #ff4d4f",
                                        background: "#fff1f0",
                                        color: "#a8071a",
                                    }
                                    : {}
                            }
                        />
                    );
                },
            },
            {
                title: "Date",
                dataIndex: 'date',
                key: 'date',
                width: 160,
                render: (_, record) => {
                    const isMissing =
                        rowErrors[record.key] && rowErrors[record.key].includes(header);

                    return (
                        <Input
                            value={record[header]}
                            onChange={(e) =>
                                handleCellChange(record.key, header, e.target.value)
                            }
                            size="small"
                            style={
                                isMissing
                                    ? {
                                        border: "1px solid #ff4d4f",
                                        background: "#fff1f0",
                                        color: "#a8071a",
                                    }
                                    : {}
                            }
                        />
                    );
                },
            },
            {
                title: "Shift",
                dataIndex: 'shift',
                key: 'shift',
                width: 160,
                render: (_, record) => {
                    const isMissing =
                        rowErrors[record.key] && rowErrors[record.key].includes(header);

                    return (
                        <Input
                            value={record[header]}
                            onChange={(e) =>
                                handleCellChange(record.key, header, e.target.value)
                            }
                            size="small"
                            style={
                                isMissing
                                    ? {
                                        border: "1px solid #ff4d4f",
                                        background: "#fff1f0",
                                        color: "#a8071a",
                                    }
                                    : {}
                            }
                        />
                    );
                },
            },
            {
                title: "In Time",
                dataIndex: 'intime',
                key: 'intime',
                width: 160,
                render: (_, record) => {
                    const isMissing =
                        rowErrors[record.key] && rowErrors[record.key].includes(header);

                    return (
                        <Input
                            value={record[header]}
                            onChange={(e) =>
                                handleCellChange(record.key, header, e.target.value)
                            }
                            size="small"
                            style={
                                isMissing
                                    ? {
                                        border: "1px solid #ff4d4f",
                                        background: "#fff1f0",
                                        color: "#a8071a",
                                    }
                                    : {}
                            }
                        />
                    );
                },
            },
            {
                title: "Out Time",
                dataIndex: 'out_time',
                key: 'out_time',
                width: 160,
                render: (_, record) => {
                    const isMissing =
                        rowErrors[record.key] && rowErrors[record.key].includes(header);

                    return (
                        <Input
                            value={record[header]}
                            onChange={(e) =>
                                handleCellChange(record.key, header, e.target.value)
                            }
                            size="small"
                            style={
                                isMissing
                                    ? {
                                        border: "1px solid #ff4d4f",
                                        background: "#fff1f0",
                                        color: "#a8071a",
                                    }
                                    : {}
                            }
                        />
                    );
                },
            },
        ]
    )
}
export const detailColumns = (type,rowErrors,headers) => {
    switch (type) {
        case "daily":
            return dailyColumns(rowErrors,headers)
        case "monthly":
            return monthlyColumns(rowErrors, headers)
    }
}